// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LiEf","col":"styles_col__2Ci5A"};